import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import Submit from 'components/react-validation/components/submit';
import { Modal } from 'react-bootstrap';
import * as Vali from 'helper/validator-helper';
import PropTypes from 'prop-types';

export default class AddEditItemModal extends Component {
  static propTypes = {
    isCreate: PropTypes.bool,
    isOpen: PropTypes.bool,
    errorMsg: PropTypes.any,
    selectListItemTrades: PropTypes.array,
    onSubmit: PropTypes.func,
    closeModal: PropTypes.func,
    title: PropTypes.string,
    item: PropTypes.object,
    onCloseModal: PropTypes.func,
    onCreateCostCode: PropTypes.func,
    onEditCostCode: PropTypes.func,
    ErrorMsg: PropTypes.any
  }
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextState) {
    if (!isEmpty(nextState.errorMsg)) {
      if (isEmpty(nextState.item)) {
        if (this.form) {
          this.form.showError(this.refs.name, nextState.errorMsg);
        }
      } else {
        if (this.form) {
          this.form.showError(this.refs.name, nextState.errorMsg);
        }

      }

    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.props.item.name) {
      this.onCreateCostCode();
    } else {
      this.onEditCostCode();
    }
  }

  onCreateCostCode = () => {
    const values = this.form.getValues();
    this.props.onCreateCostCode(
      {
        data: {
          name: values.name,
          code: values.code
        }
      }
    );
  }

  onEditCostCode = () => {
    const values = this.form.getValues();
    this.props.onEditCostCode(
      {
        id: this.props.item.id,
        data: {
          name: values.name,
          code: values.code
        }
      }
    );
  }

  onCloseModal = () => {
    this.props.onCloseModal();
  }

  render() {
    let { name, code } = this.props.item;
    if (this.form) {
      name = this.form.getValues().name;
      code = this.form.getValues().code;
    }
    return (
      <div className=''>
        <Modal show={this.props.isOpen}>
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>{isEmpty(this.props.item) ? 'New cost code' : `Edit ${this.props.item.name}`}</Modal.Title>
            <button className='close' onClick={this.onCloseModal} >&times;</button>
          </Modal.Header>
          <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit}>
            <Modal.Body>
              <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
              <div className='form-group'>
                <label>Name <strong className='text-danger'>*</strong></label>
                <Input
                  name='name'
                  ref='name'
                  placeholder='Name'
                  className='form-control'
                  autoFocus
                  value={name}
                  max='100'
                  maxLength='100'
                  errorMsg={this.props.errorMsg}
                  validations={[Vali.required, Vali.maxlength]} />
              </div>
              <div className='form-group'>
                <label>Cost code <strong className='text-danger'>*</strong></label>
                <Input
                  name='code'
                  ref='code'
                  placeholder='Cost code'
                  className='form-control'
                  value={code}
                  max='100'
                  maxLength='100'
                  validations={[Vali.required, Vali.maxlength]} />
              </div>
            </Modal.Body>

            <Modal.Footer >
              <span className='btn btn-default btn-siteone-default' onClick={this.onCloseModal}>Cancel</span>
              <Submit className='btn btn-primary btn-siteone'>{isEmpty(this.props.item) ? 'Create' : 'Save'}</Submit>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/CostCodes/Components/add-edit-cost-code-modal.js